export const categoryIcons = {
  General: "fal fa-stethoscope",
  Cardiovascular: "fal fa-heart",
  Respiratory: "fal fa-lungs",
  Gastrointestinal: "fal fa-stomach",
  GenitoUrinary: "fal fa-kidneys",
  Nervous: "fal fa-brain",
  Skin: "fal fa-allergies",
  Eye: "fal fa-eye",
  Musculoskeletal: "fal fa-bone",
  "My Patient": "fal fa-head-side-medical",
  CBC: "fal fa-vial",
  Chemistry: "fal fa-flask",
  Infectious: "fal fa-virus",
  "Coagulation screen": "fal fa-puzzle-piece",
  "Blood Gases": "fal fa-wind",
  Liver: "fal fa-recycle",
  Thyroid: "fal fa-industry",
  "Inflammatory ": "fal fa-certificate",
  Rheumatology: "fal fa-hand-pointer",
  LIPID: "fal fa-hamburger",
  Lipids: "fal fa-hamburger",
  Urine: "fal fa-kidneys",

  "Urine Dipstick": "fal fa-faucet-drip",
  "Urine Collection (24h)": "fal fa-shower",

  "Chest Xray": "fal fa-x-ray",

  ECG: "fal fa-heart-rate",

  "Most Relevant": "fal fa-exclamation-circle",
};
